import { ReactNode } from 'react';

import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations';

export const FormWithPaymentOverlay = ({
	children,
	paymentDetailsPage,
	fullViewportOverlay,
}: {
	children: ReactNode;
	paymentDetailsPage?: ReactNode;
	/** When true, overlay covers the whole viewport (e.g. to hide layout behind it). */
	fullViewportOverlay?: boolean;
}) => {
	const overlayContent = paymentDetailsPage ?? null;

	return (
		<div css={wrapperCss}>
			{children}
			{overlayContent && fullViewportOverlay && (
				<div css={[overlayCss, overlayFullViewportCss]}>{overlayContent}</div>
			)}
			{overlayContent && !fullViewportOverlay && <div css={overlayCss}>{overlayContent}</div>}
		</div>
	);
};

const wrapperCss = css({
	position: 'relative',
});

const overlayCss = css({
	position: 'absolute',
	inset: 0,
	zIndex: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	backgroundColor: wacToken('color.neutral.light0'),
});

const overlayFullViewportCss = css({
	position: 'fixed',
	zIndex: 9999,
});
